import { UserState } from "../components/Authorization/AuthorizationState";

export function buildHeaders(user: UserState) {
  return {
    "Content-Type": "application/json",
    Authorization: `${user.token}`,
    "Selected-Role": `${user.selectedRoles?.at(0) ?? ""}`,
  };
}
